export const marketsData = [
    {key: 'all', text: 'ALL', value: 'all'},
    {key: 'false', text: 'Hayır', value: 'false'},

];